import React, { useState } from "react";
import { Card, Grid, Icon, TextField } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import {
  getEmployeeActivityReportList,
  exportEmployeeActivityReportData,
} from "actions/reports";
import { employeeActivityReportList } from "constants/reports";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getContractorList } from "actions/contractor";
import { contractorList } from "constants/contractor";
import { getDepartmentList } from "actions/department";
import { getDesignationList } from "actions/designation";
import { getTechnicianList } from "actions/technician";
import { Autocomplete } from "@mui/material";
import {
  autoCompleteProps,
  wrapCell,
} from "components/CommonComponent/CommonFunction";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  DATE_RANGE_OPTIONS,
  DEFAULT_RECORDS_PER_PAGE,
  AGGREGATE_OPTIONS,
} from "components/common/constant";
import { useNotify } from "components/CommonComponent/NotificationProvider";

function EmployeeMasterListing() {
  const dispatch = useDispatch();
  const userData = JSON.parse(localStorage.getItem("p"));
  const [pageNum, setPageNum] = useState(1);
  const [filters, setFilters] = useState(() => {
    const endDate = new Date();
    const startDate = new Date();

    const startDateString = startDate.toISOString().split("T")[0];
    const endDateString = endDate.toISOString().split("T")[0];

    return {
      dateRange: "TODAY",
      startDate: startDateString,
      endDate: endDateString,

      // employeeName: "",
      employeeID: "",
      contractorName: "",
      department: "",
      departmentCode: "",
      designation: "",
      technicianName: "",
      aggregate: "",

      filterParams: JSON.stringify([
        {
          field: "Date",
          condition: "gte",
          filterValues: [startDateString],
        },
        {
          field: "Date",
          condition: "lte",
          filterValues: [endDateString],
        },
        // {
        //   field: "Aggregate",
        //   condition: "eq",
        //   filterValues: ["Employee"],
        // },
      ]),
    };
  });
  const [listState, setListState] = useState({
    isLoading: true,
    error: "",
    noRecords: false,
    showLoaderOnClick: false,
  });
  const [showClearButton, setShowClearButton] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);

  const { notify } = useNotify();
  const contractorListData = useSelector(
    (state) => state.contractor.contractorList,
  );
  const reportListData = useSelector(
    (state) => state.employeeActivityReport?.employeeActivityReportList,
  );
  const departmentListData = useSelector(
    (state) => state.department.departmentList,
  );
  const designationListData = useSelector(
    (state) => state.designation.designationList,
  );
  const technicianListData = useSelector(
    (state) => state.technician.technicianList,
  );

  useEffect(() => {
    getEmployeeActivityReportList(dispatch, pageNum, filters.filterParams);

    return () => {
      dispatch({ type: employeeActivityReportList, payload: {} });
    };
  }, [dispatch, pageNum, filters.filterParams]);

  useEffect(() => {
    if (reportListData?.code === 200) {
      setListState({
        isLoading: false,
        error: "",
        noRecords: reportListData?.data?.PendingTimesheetResponse?.length === 0,
        showLoaderOnClick: false,
      });
    } else if (reportListData?.code || reportListData?.message) {
      setListState({
        isLoading: false,
        error:
          reportListData?.message ||
          "Failed to load employee report! Please try again.",
        noRecords: false,
        showLoaderOnClick: false,
      });
    }
  }, [reportListData]);

  useEffect(() => {
    getContractorList(dispatch);
    getDepartmentList(dispatch);
    getDesignationList(dispatch);
    getTechnicianList(dispatch);
  }, [dispatch]);

  const getDateRange = (days) => {
    const today = new Date();

    if (days === "TODAY") {
      const todayString = dayjs(today).format("YYYY-MM-DD");

      return {
        startDate: todayString,
        endDate: todayString,
      };
    }

    const endDate = new Date(today);
    endDate.setDate(endDate.getDate() - 1);

    if (days === "1") {
      const yesterdayString = dayjs(endDate).format("YYYY-MM-DD");

      return {
        startDate: yesterdayString,
        endDate: yesterdayString,
      };
    }

    const startDate = new Date(endDate);
    startDate.setDate(startDate.getDate() - (Number(days) - 1));

    return {
      startDate: dayjs(startDate).format("YYYY-MM-DD"),
      endDate: dayjs(endDate).format("YYYY-MM-DD"),
    };
  };

  const tableData =
    reportListData?.data?.PendingTimesheetResponse?.map((item, index) => ({
      srNo: index + 1,
      date: item?.date || "-",
      employeeName: item?.employeeName || "-",
      employeeID: item?.employeeID || "-",
      contractorName: item?.contractorName || "-",
      department: item?.departmentName || "-",
      deptCode: item?.departmentCode || "-",
      designation: item?.designation || "-",
      count: item?.count || "-",
    })) || [];

  const buildFilterParams = () => {
    const filterParams = [];

    // mandatory date range
    filterParams.push({
      field: "Date",
      condition: "gte",
      filterValues: [filters.startDate],
    });

    filterParams.push({
      field: "Date",
      condition: "lte",
      filterValues: [filters.endDate],
    });

    if (filters.employeeName?.trim()) {
      filterParams.push({
        field: "EmployeeName",
        condition: "like",
        filterValues: [filters.employeeName.trim()],
      });
    }

    if (filters.employeeID?.trim()) {
      filterParams.push({
        field: "EmployeeID",
        condition: "like",
        filterValues: [filters.employeeID.trim()],
      });
    }

    if (filters.department) {
      const selectedDepartment = departmentListData?.data?.Department?.find(
        (item) => item.ID === filters.department,
      );

      if (selectedDepartment) {
        filterParams.push({
          field: "DepartmentName",
          condition: "like",
          filterValues: [selectedDepartment.name],
        });

        filterParams.push({
          field: "DepartmentCode",
          condition: "like",
          filterValues: [selectedDepartment.code],
        });
      }
    }

    if (filters.designation) {
      const selectedDesignation = designationListData?.data?.Designation?.find(
        (item) => item.ID === filters.designation,
      );

      if (selectedDesignation) {
        filterParams.push({
          field: "Designation",
          condition: "like",
          filterValues: [selectedDesignation.name],
        });
      }
    }

    if (filters.contractorName) {
      const selectedContractor = contractorListData?.data?.Contractor?.find(
        (item) => item.ID === filters.contractorName,
      );

      if (selectedContractor) {
        filterParams.push({
          field: "ContractorName",
          condition: "like",
          filterValues: [selectedContractor.name],
        });
      }
    }

    if (filters.aggregate) {
      filterParams.push({
        field: "Aggregate",
        condition: "eq",
        filterValues: [filters.aggregate],
      });
    }

    if (filters.technicianName) {
      const technician = technicianListData?.data?.Technicians?.find(
        (item) => item.id === filters.technicianName,
      );

      if (technician) {
        filterParams.push({
          field: "EmployeeName",
          condition: "like",
          filterValues: [technician.name],
        });
      }
    }

    return JSON.stringify(filterParams);
  };

  const columns = [
    { Header: "Sr No", accessor: "srNo", width: "115px" },

    {
      Header: "Date",
      accessor: "date",
      width: "110px",
      Cell: (cell) => wrapCell(cell.value, "110px"),
    },

    {
      Header: "Employee Name",
      accessor: "employeeName",
      width: "190px",
      Cell: (cell) => wrapCell(cell.value, "190px"),
    },

    {
      Header: "Employee ID",
      accessor: "employeeID",
      width: "165px",
      Cell: (cell) => wrapCell(cell.value, "165px"),
    },

    {
      Header: "Contractor Name",
      accessor: "contractorName",
      width: "210px",
      Cell: (cell) => wrapCell(cell.value, "210px"),
    },

    {
      Header: "Department",
      accessor: "department",
      width: "165px",
      Cell: (cell) => wrapCell(cell.value, "165px"),
    },

    {
      Header: "Dept Code",
      accessor: "deptCode",
      width: "150px",
      Cell: (cell) => wrapCell(cell.value, "120px"),
    },

    {
      Header: "Designation",
      accessor: "designation",
      width: "165px",
      Cell: (cell) => wrapCell(cell.value, "165px"),
    },
    {
      Header: "Count",
      accessor: "count",
      width: "125px",
      Cell: (cell) => wrapCell(cell.value, "165px"),
    },
  ];

  const handleSearch = () => {
    const filterParams = buildFilterParams();

    if (filterParams === filters.filterParams) {
      return;
    }

    setListState((prev) => ({
      ...prev,
      isLoading: true,
      showLoaderOnClick: true,
    }));

    setFilters((prev) => ({
      ...prev,
      filterParams,
    }));

    setShowClearButton(true);

    if (pageNum !== 1) {
      setPageNum(1);
    }
  };

  const handleClear = () => {
    const endDate = new Date();
    const startDate = new Date();

    const startDateString = startDate.toISOString().split("T")[0];
    const endDateString = endDate.toISOString().split("T")[0];

    setFilters({
      dateRange: "TODAY",
      startDate: startDateString,
      endDate: endDateString,
      aggregate: "",
      employeeName: "",
      employeeID: "",
      contractorName: "",
      department: "",
      departmentCode: "",
      designation: "",
      technicianName: "",

      filterParams: JSON.stringify([
        {
          field: "Date",
          condition: "gte",
          filterValues: [startDateString],
        },
        {
          field: "Date",
          condition: "lte",
          filterValues: [endDateString],
        },
        // {
        //   field: "Aggregate",
        //   condition: "eq",
        //   filterValues: ["Employee"],
        // },
      ]),
    });

    setShowClearButton(false);

    if (pageNum !== 1) {
      setPageNum(1);
    }
  };
  const handleExportExcel = () => {};

  const handleExportPDF = () => {};

  const downloadUnfilledTimesheetReportCSV = async () => {
    try {
      setExportLoading(true);

      const res = await exportEmployeeActivityReportData(filters.filterParams);
      
      const url = window.URL.createObjectURL(res.data);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "UnfilledTimesheetReport.csv");

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      notify(
        res?.message || "UnfilledTimesheetReport file downloaded successfully",
        "success",
      );
    } catch (error) {
      notify("Failed to download unfilledTimesheetReport file", "error");
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox width="100%">
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                px={3}
                pt={3}
                pb={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h5" fontWeight="bold">
                  Unfilled Timesheet Report
                </MDTypography>

                <MDBox display="flex" gap={2}>
                  {/* <MDButton
                    variant="gradient"
                    color="light"
                    startIcon={<Icon>download</Icon>}
                    sx={{
                      py: 1.2,
                      px: 3,
                      fontWeight: "bold",
                      textTransform: "none",
                    }}
                    onClick={handleExportExcel}
                  >
                    Export Excel
                  </MDButton>

                  <MDButton
                    variant="gradient"
                    color="light"
                    startIcon={<Icon>picture_as_pdf</Icon>}
                    sx={{
                      py: 1.2,
                      px: 3,
                      fontWeight: "bold",
                      textTransform: "none",
                    }}
                    onClick={handleExportPDF}
                  >
                    Export PDF
                  </MDButton> */}
                  <MDButton
                    variant="gradient"
                    color="light"
                    startIcon={<Icon>file_upload</Icon>}
                    sx={{
                      py: 1.2,
                      px: 3,
                      fontWeight: "bold",
                      textTransform: "none",
                    }}
                    onClick={downloadUnfilledTimesheetReportCSV}
                  >
                    {exportLoading ? (
                      <>
                        <i className="fa fa-spinner fa-spin mr-2" />
                        Exporting...
                      </>
                    ) : (
                      "Export Report"
                    )}
                  </MDButton>
                </MDBox>
              </MDBox>

              <MDBox px={3} pb={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      {...autoCompleteProps}
                      disablePortal
                      size="small"
                      options={DATE_RANGE_OPTIONS}
                      value={
                        DATE_RANGE_OPTIONS.find(
                          (item) => item.value === filters.dateRange,
                        ) || null
                      }
                      getOptionLabel={(option) => option.label}
                      onChange={(event, value) => {
                        if (!value) return;

                        if (value.value === "CUSTOM") {
                          setFilters({
                            ...filters,
                            dateRange: "CUSTOM",
                          });
                        } else {
                          const dates = getDateRange(value.value);

                          setFilters({
                            ...filters,
                            dateRange: value.value,
                            startDate: dates.startDate,
                            endDate: dates.endDate,
                          });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Date Range"
                        />
                      )}
                    />
                  </Grid>

                  {filters.dateRange === "CUSTOM" && (
                    <>
                      <Grid item xs={12} sm={6} md={4} lg={2}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            disableFuture
                            label="Start Date"
                            value={dayjs(filters.startDate)}
                            onChange={(value) =>
                              setFilters((prev) => ({
                                ...prev,
                                startDate: value?.format("YYYY-MM-DD") || "",
                              }))
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                size: "small",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>

                      <Grid item xs={12} sm={6} md={4} lg={2}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            disableFuture
                            label="End Date"
                            minDate={dayjs(filters.startDate)}
                            value={dayjs(filters.endDate)}
                            onChange={(value) =>
                              setFilters((prev) => ({
                                ...prev,
                                endDate: value?.format("YYYY-MM-DD") || "",
                              }))
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                size: "small",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </>
                  )}

                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      {...autoCompleteProps}
                      disablePortal
                      size="small"
                      options={technicianListData?.data?.Technicians || []}
                      getOptionLabel={(option) => option?.name || ""}
                      value={
                        technicianListData?.data?.Technicians?.find(
                          (item) => item.id === filters.technicianName,
                        ) || null
                      }
                      onChange={(event, newValue) =>
                        setFilters((prev) => ({
                          ...prev,
                          technicianName: newValue?.id || "",
                          technicianId: newValue?.id || "",
                        }))
                      }
                      isOptionEqualToValue={(option, value) =>
                        option?.id === value?.id
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Technician"
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      {...autoCompleteProps}
                      disablePortal
                      size="small"
                      options={AGGREGATE_OPTIONS}
                      getOptionLabel={(option) => option?.label || ""}
                      value={
                        AGGREGATE_OPTIONS.find(
                          (item) => item.value === filters.aggregate,
                        ) || null
                      }
                      onChange={(event, newValue) =>
                        setFilters((prev) => ({
                          ...prev,
                          aggregate: newValue?.value || "",
                        }))
                      }
                      isOptionEqualToValue={(option, value) =>
                        option?.value === value?.value
                      }
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select Aggregate" />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Search by Name"
                      value={filters.employeeName}
                      onChange={(e) =>
                        setFilters({
                          ...filters,
                          employeeName: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Search by Emp ID"
                      value={filters.employeeID}
                      onChange={(e) =>
                        setFilters({
                          ...filters,
                          employeeID: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      {...autoCompleteProps}
                      disablePortal
                      size="small"
                      options={contractorListData?.data?.Contractor || []}
                      getOptionLabel={(option) => option?.name || ""}
                      value={
                        contractorListData?.data?.Contractor?.find(
                          (item) => item.ID === filters.contractorName,
                        ) || null
                      }
                      onChange={(event, newValue) =>
                        setFilters({
                          ...filters,
                          contractorName: newValue?.ID || "",
                        })
                      }
                      isOptionEqualToValue={(option, value) =>
                        option?.ID === value?.ID
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Contractor Name"
                        />
                      )}
                    />
                  </Grid>

                  {userData?.role === "ADMIN" && (
                    <>
                      <Grid item xs={12} sm={6} md={4} lg={2}>
                        <Autocomplete
                          {...autoCompleteProps}
                          disablePortal
                          size="small"
                          options={departmentListData?.data?.Department || []}
                          getOptionLabel={(option) => option?.name || ""}
                          value={
                            departmentListData?.data?.Department?.find(
                              (item) => item.ID === filters.department,
                            ) || null
                          }
                          onChange={(event, newValue) =>
                            setFilters({
                              ...filters,
                              department: newValue?.ID || "",
                              departmentCode: newValue?.code || "",
                            })
                          }
                          isOptionEqualToValue={(option, value) =>
                            option?.ID === value?.ID
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Department"
                            />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={4} lg={2}>
                        <Autocomplete
                          {...autoCompleteProps}
                          disablePortal
                          size="small"
                          options={departmentListData?.data?.Department || []}
                          getOptionLabel={(option) => option?.code || ""}
                          value={
                            departmentListData?.data?.Department?.find(
                              (item) => item.code === filters.departmentCode,
                            ) || null
                          }
                          onChange={(event, newValue) =>
                            setFilters({
                              ...filters,
                              departmentCode: newValue?.code || "",
                              department: newValue?.ID || "",
                            })
                          }
                          isOptionEqualToValue={(option, value) =>
                            option?.ID === value?.ID
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Department Code"
                            />
                          )}
                        />
                      </Grid>
                    </>
                  )}

                  <Grid item xs={12} sm={6} md={4} lg={2}>
                    <Autocomplete
                      {...autoCompleteProps}
                      disablePortal
                      size="small"
                      options={designationListData?.data?.Designation || []}
                      getOptionLabel={(option) => option?.name || ""}
                      value={
                        designationListData?.data?.Designation?.find(
                          (item) => item.ID === filters.designation,
                        ) || null
                      }
                      onChange={(event, newValue) =>
                        setFilters({
                          ...filters,
                          designation: newValue?.ID || "",
                        })
                      }
                      isOptionEqualToValue={(option, value) =>
                        option?.ID === value?.ID
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Designation"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <MDBox display="flex" gap={1}>
                      <MDButton
                        variant="contained"
                        color="deepBlue"
                        onClick={handleSearch}
                        disabled={listState.showLoaderOnClick}
                      >
                        {listState.showLoaderOnClick ? (
                          <i className="fa fa-spinner fa-spin fa-lg text-white" />
                        ) : (
                          <>
                            <Icon sx={{ mr: 1 }}>search</Icon>
                            Search
                          </>
                        )}
                      </MDButton>

                      {showClearButton && (
                        <MDButton
                          variant="contained"
                          color="deepBlue"
                          onClick={handleClear}
                        >
                          <Icon sx={{ mr: 1 }}>close</Icon>
                          Clear
                        </MDButton>
                      )}
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>

              <MDBox px={3} py={1}>
                <MDTypography variant="body1" color="deepBlue">
                  Total Records: {reportListData?.data?.totalRecords || 0}
                </MDTypography>
              </MDBox>

              <MDBox sx={{ width: "100%", overflowX: "auto" }}>
                {listState.isLoading ? (
                  <MDBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="150px"
                  >
                    <i className="fa fa-spinner fa-spin fa-2xl loader" />
                  </MDBox>
                ) : listState.error ? (
                  <MDBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="150px"
                  >
                    <MDTypography variant="body2" color="error">
                      {listState.error}
                    </MDTypography>
                  </MDBox>
                ) : listState.noRecords ? (
                  <MDBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="150px"
                  >
                    <MDTypography variant="body2" color="text">
                      No records found.
                    </MDTypography>
                  </MDBox>
                ) : (
                  <DataTable
                    columns={columns}
                    data={tableData || []}
                    isSorted={true}
                    pageNum={pageNum}
                    setPageNum={setPageNum}
                    totalPages={Math.ceil(
                      (reportListData?.data?.totalRecords || 0) /
                        (reportListData?.data?.noOfRecordsPerPage ||
                          DEFAULT_RECORDS_PER_PAGE),
                    )}
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default EmployeeMasterListing;
